import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { setRange } from 'features/report/reportAddSlice'
import DomainFilter from 'features/report/filters/DomainFilter'
import DomainStatusFilter from 'features/report/filters/DomainStatusFilter'
import CampaignGroupFilter from 'features/report/filters/CampaignGroupFilter'
import MetricTypeFilter from 'features/report/filters/MetricTypeFilter'
import AnalysisFilter from 'features/report/filters/AnalysisFilter'
import DateRangePicker from 'components/calendar/DateRangePicker'
import useCalendarRange from 'components/calendar/useCalendarRange'
import { AD_ACCOUNT, CAMPAIGN } from 'features/report/common/DomainText'
import { maximum } from 'components/calendar/calendarUtil'
import Icon from 'components/Icon'
import Button from 'components/form/Button'
import { downloadCsvFile } from 'utils'
import { fail } from 'features/toast/Toast'
import api from 'api/axios/foka'
import { hideBackDrop, showBackDrop } from 'features/dialog/backDropSlice'

const ReportAddHeader = () => {
  const dispatch = useDispatch()
  const { min, max } = useCalendarRange(moment().subtract(2, 'year'))
  const handleRangeChange = (start, end, preset) => {
    dispatch(
      setRange({
        start,
        end,
        preset,
      })
    )
  }
  const {
    formValues: {
      domain,
      period: { specific },
      calendarPreset,
    },
    isLoading,
    reports,
    formValues,
  } = useSelector(state => state.report.reportAdd)
  const accountName = useSelector(state => state.account.current.name)
  const handleDownloadCSVFile = async () => {
    dispatch(showBackDrop())
    try {
      const response = await api.report.downloadDomainReports({
        domain,
        param: formValues,
      })
      downloadCsvFile(
        response.data,
        `${accountName}_맞춤보고서_${specific.start.replace(
          /-/gi,
          ''
        )}_${specific.end.replace(/-/gi, '')}.csv`
      )
    } catch (e) {
      fail(
        e.code === 404
          ? '다운로드할 데이터가 없습니다.'
          : '알 수 없는 에러가 발생했습니다.'
      )
    }
    dispatch(hideBackDrop())
  }
  return (
    <div className="set_head">
      <div className="f_left">
        <DomainFilter />
        {domain !== AD_ACCOUNT && <DomainStatusFilter />}
        {domain !== AD_ACCOUNT && domain !== CAMPAIGN && (
          <CampaignGroupFilter />
        )}
      </div>
      <div className="f_right">
        {domain !== AD_ACCOUNT && <MetricTypeFilter />}
        <AnalysisFilter />
        <div className="single_wrap">
          <div className="group_calendar">
            <DateRangePicker
              type="simple"
              start={maximum(min, specific.start)}
              end={specific.end}
              preset={calendarPreset}
              min={min}
              max={max}
              onChange={handleRangeChange}
              tiaraPrefix="보고서"
            />
          </div>
        </div>
        <div className="single_wrap">
          <Button
            line
            icon
            disabled={isLoading === true || reports.length === 0}
            onClick={handleDownloadCSVFile}>
            <Icon name="download">다운로드</Icon>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ReportAddHeader
